import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Container,
  Divider,
  Drawer,
  Grid,
  IconButton,
  InputBase,
  List,
  ListItem,
  Paper,
  Skeleton,
  Stack,
  Typography,
  Button,
  Fab,
  Tooltip,
  Modal,
  Dialog,
  DialogTitle,
} from '@mui/material';
import { searchProducts } from '../APIs/action';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import CartAndAddressComponent from '../Components/CartAndAddressComponent';
import { FilterAlt, Search } from '@mui/icons-material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { SecondarySchemeIcon } from './Utils/SecondarySchemeIcon';
import { navigateToAddStpDetails } from '../BCMOrder/functions';
import AddRemoveQty from '../Components/AddRemoveQty';
import { OperationType, unitCaseEnum } from '../../utils/settings';
import { FilterComponent } from './FilterComponent';

const itemCount = 1000;
function ProductList() {
  const { state } = useLocation();
  const [productListData, setProductListData] = useState([]);
  const [ifAutoSuggestionSelected, setIfAutoSuggestionSelected] =
    useState(false);
  const [autoCompleteSuggestions, setAutoCompleteSuggestions] = useState([]);
  const [selectedFiltersList, setSelectedFiltersList] = useState([]);
  const [filters, setFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState('');
  const [promptOpen, setPromptOpen] = useState(false);
  const [openSizeModal, setOpenSizeModal] = useState(false);
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);
  const [prodData, setProdData] = useState({});

  const {
    addedUserList,
    selectedStp,
    isPaintFlow,
    isFmcgFlow,
    isSecondaryOrder,
    supplier_id,
    companyDetails,
    booking_editorder_details,
    userIndex,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      selectedStp: state.bcmOrderReducer.selectedStp,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      isFmcgFlow: state.bcmOrderReducer.isFmcgFlow,
      isSecondaryOrder: state.bcmOrderReducer.isSecondaryOrder,
      supplier_id: state.bcmOrderReducer.supplier_id,
      companyDetails: state.orderReducer.companyDetails,
      booking_editorder_details:
        state.bcmOrderReducer.booking_editorder_details,
      userIndex: state.fmcgReducer.userIndex,
    };
  });

  const sizes = !(isSecondaryOrder && isFmcgFlow)
    ? [{ label: 'Case', value: 1 }]
    : [
        { label: 'Case', value: 1 },
        { label: 'Unit', value: 2 },
      ];
  const [selectedSize, setSelectedSize] = useState(sizes[0].value);

  const search = async (params) => {
    setIsLoading(true);
    let res = {};

    let queryParams = {
      search_index: 'sku-master',
    };
    if (selectedStp?.delivery_pricing_geography_id) {
      queryParams['pricing_geography_id'] =
        selectedStp.delivery_pricing_geography_id;
    }

    if (
      isSecondaryOrder ||
      (state?.isFromEditOrderDetails && state?.seller_id !== state?.supplier_id)
    ) {
      queryParams['distributor_id'] = isSecondaryOrder
        ? supplier_id.id
        : state?.seller_id;
    }

    res = await searchProducts(params, queryParams);
    const { data, error, message } = res;
    setIsLoading(false);

    if (!error) {
      setProductListData(data.hits);
    } else {
      return toast.error('Error in fetching data');
    }
  };
  useEffect(() => {
    getInitialAllProducts();
    getFilters();
  }, []);
  const getInitialAllProducts = async () => {
    let params = {
      query: {
        match: {
          company_id: {
            query: state?.distributor_id,
          },
        },
      },
      size: itemCount,
    };

    search(params);
  };

  const getAutocompleteSuggestions = async (searchQuery) => {
    if (searchQuery.length >= 3 && !ifAutoSuggestionSelected) {
      let params = {
        query: {
          bool: {
            must: [
              {
                match_phrase_prefix: {
                  name: {
                    query: searchQuery,
                  },
                },
              },
              {
                match: {
                  company_id: state?.distributor_id,
                },
              },
            ],
          },
        },
        size: itemCount,
      };
      let res = {};

      let queryParams = {
        search_index: 'sku-master',
      };

      if (selectedStp?.delivery_pricing_geography_id) {
        queryParams['pricing_geography_id'] =
          selectedStp.delivery_pricing_geography_id;
      }

      if (
        isSecondaryOrder ||
        (state?.isFromEditOrderDetails &&
          state?.seller_id !== state?.supplier_id)
      ) {
        queryParams['distributor_id'] = isSecondaryOrder
          ? supplier_id.id
          : state?.seller_id;
      }

      res = await searchProducts(params, queryParams);
      const { data, error, message } = res;
      if (!error) {
        setAutoCompleteSuggestions(data.hits);
      } else {
        return toast.error('Error in fetching data');
      }
    } else {
      setAutoCompleteSuggestions([]);
    }
  };
  const getFilters = async () => {
    let params = {
      query: {
        term: {
          company_id: Number(state?.distributor_id),
        },
      },
      size: itemCount,
    };
    let res = {};

    let queryParams = {
      search_index: 'sku-master',
    };

    if (selectedStp?.delivery_pricing_geography_id) {
      queryParams['pricing_geography_id'] =
        selectedStp.delivery_pricing_geography_id;
    }

    if (
      isSecondaryOrder ||
      (state?.isFromEditOrderDetails && state?.seller_id !== state?.supplier_id)
    ) {
      queryParams['distributor_id'] = isSecondaryOrder
        ? supplier_id.id
        : state?.seller_id;
    }

    res = await searchProducts(params, queryParams);
    const { data, error, message } = res;
    if (!error) {
      setFilters(data.category_filters);
    }
  };

  useEffect(() => {
    if (searchQuery.length > 2) {
      getAutocompleteSuggestions(searchQuery);
    } else {
      setAutoCompleteSuggestions([]);
      getInitialAllProducts();
    }
  }, [searchQuery]);

  const handleSearch = (searchQuery) => {
    if (searchQuery.length > 2) {
      let params = {
        query: {
          bool: {
            must: [
              {
                match_phrase_prefix: {
                  message: searchQuery,
                },
              },
              {
                match: {
                  company_id: state?.distributor_id,
                },
              },
            ],
          },
        },
        size: itemCount,
      };
      search(params);
    } else {
      getInitialAllProducts();
    }
  };

  useEffect(() => {
    if (selectedFiltersList.length > 0) {
      const query = generateQuery(selectedFiltersList);

      search(query);
    } else {
      getInitialAllProducts();
    }
  }, [selectedFiltersList]);

  function generateQuery(outputSet) {
    let query = {
      query: {
        bool: {
          filter: [
            {
              term: {
                company_id: {
                  value: state?.distributor_id,
                },
              },
            },
          ],
          should: [],
          minimum_should_match: 1,
        },
      },
      size: itemCount,
    };

    for (let i = 0; i < outputSet.length; i++) {
      let parts = outputSet[i].split('|');
      let boolQuery = {
        bool: {
          filter: [],
        },
      };

      for (let j = 0; j < parts.length; j++) {
        boolQuery.bool.filter.push({
          term: {
            [`meta_data.category_value${j + 1}.keyword`]: {
              value: parts[j],
            },
          },
        });
      }

      query.query.bool.should.push(boolQuery);
    }

    return query;
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setIsFiltersModalOpen(open);
  };

  const applyFiltersAction = () => {
    setIsFiltersModalOpen(false);
  };

  const cancelFiltersAction = () => {
    setIsFiltersModalOpen(false);
  };
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const handleModalOpen = (data) => {
    setOpen(true);
    setModalData(data);
  };
  const handleModalClose = () => {
    setOpen(false);
    setModalData([]);
  };
  const secondarySchemeModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          height: 900,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Carousel
            useKeyboardArrows={true}
            autoPlay={true}
            showStatus={false}
            showIndicators={false}
            infiniteLoop={true}
          >
            {modalData?.map((url, index) => (
              <img
                alt='sample_file'
                src={url}
                key={index}
              />
            ))}
          </Carousel>
        </Box>
      </Box>
    </Modal>
  );

  const handleClose = () => {
    setPromptOpen(false);
  };

  function PromptAddShipToParty(props) {
    const { onCloseDialog, openDialog } = props;

    return (
      <Dialog
        onClose={onCloseDialog}
        open={openDialog}
      >
        <Box
          sx={{
            p: 3,
            px: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DialogTitle
            variant='h5'
            sx={{ fontWeight: 'bold' }}
          >
            No Ship to Party Selected
          </DialogTitle>
          <Typography>To Continue, please add Ship to Party</Typography>

          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: 3,
            }}
          >
            <Button
              onClick={onCloseDialog}
              variant='contained'
              color='error'
            >
              Cancel
            </Button>

            <Button
              onClick={() => {
                navigateToAddStpDetails({
                  dispatch,
                  navigate,
                });
              }}
              variant='contained'
            >
              Add Now
            </Button>
          </Stack>
        </Box>
      </Dialog>
    );
  }

  const promptUserToAddStp = () => {
    setPromptOpen(true);
  };

  const checkIfStpSelected = () => {
    if (
      addedUserList.length === 0 ||
      (addedUserList.length > 0 && Object.keys(selectedStp).length === 0)
    )
      return promptUserToAddStp();
    else return true;
  };
  useEffect(() => {
    if (productListData.length > 0) {
      const timer = setTimeout(() => {
        checkIfStpSelected(true);
      }, 100); // Delay to ensure the UI has stabilized
      return () => clearTimeout(timer);
    }
  }, [productListData]);
  const onAddToBag = ({
    productData,
    qty,
    decreasing = false,
    size = null,
  }) => {
    let newSize = size || selectedSize;
    const addedProd =
      selectedStp?.products?.find(
        (prod) => prod.product_id === prodData.product_id,
      ) || {};

    if (Object.keys(addedProd).length > 0) {
      newSize = addedProd.product_size;
    }

    if (state?.isFromEditOrderDetails) {
      const shipToParty = booking_editorder_details.shipment_details.filter(
        (item) =>
          item.ship_to_party_info.company_info.id === state.ship_to_party_id,
      )[0];

      const obj = {
        ...shipToParty,
        product_summary_info: [
          ...shipToParty.product_summary_info,
          {
            name: productData.name,
            product_id: productData.product_id,
            operation_type: OperationType['ADD'],
            pending: {
              quantity_in_metric_ton: Number(qty),
              multiplier: productData.multiplier,
              unit: newSize === unitCaseEnum['UNIT'] ? 'Unit' : 'Case(s)',
            },
            price_info: {
              price:
                newSize === unitCaseEnum['UNIT']
                  ? Number(productData.meta_data.price.rlp)
                  : Number(productData.meta_data.price.dlp),
              unit: '₹',
            },
            delivered: {
              quantity_in_bags: 0,
              quantity_in_metric_ton: 0,
              multiplier: productData.multiplier,
              quantity: 0,
              unit: newSize === unitCaseEnum['UNIT'] ? 'Unit' : 'Case(s)',
            },
          },
        ],
      };

      dispatch({
        type: 'ADD_PRODUCT_EDIT_PO_BOOKING_DETAILS',
        data: obj,
      });

      navigate(-2);
    } else {
      if (isPaintFlow && addedUserList.length === 0) {
        return toast.error(
          'Please add delivery details to add products to cart',
        );
      } else {
        if (newSize === null) {
          return toast.error('Please Select Packaging');
        }
        if (qty === null) {
          return toast.error('Please Enter Quantity');
        }
        if (isNaN(qty)) {
          return toast.error('Please Enter  Quantity in Numbers ');
        }

        const user = addedUserList[userIndex];
        const productObj = {
          product_size: newSize,
          product_id: productData.product_id,
          product_multiplier: Number(productData.meta_data.multiplier),
          qty: !isSecondaryOrder
            ? Number(qty)
            : newSize === unitCaseEnum['UNIT']
            ? Number(qty)
            : Number(qty * productData?.meta_data?.Case_Size),
          product_data: productData,
        };

        if (user.products && user.products.length > 0) {
          const index = user?.products?.findIndex(
            (prev) => prev.product_id === productObj.product_id,
          );
          const productList = user.products;
          if (index !== -1) {
            if (qty === 0) productList.splice(index, 1);
            else {
              productList[index] = productObj;
              user.products = productList;
            }
          } else {
            user.products = [...user.products, productObj];
          }
        } else {
          user.products = [productObj];
        }
        const list = [...addedUserList];
        list.splice(userIndex, 1, user);
        dispatch({
          type: 'SET_USER_LIST',
          data: list,
        });

        if (qty === 1 && !decreasing)
          return toast.success('Product added to cart');
      }
    }
  };

  const addQty = (data, qty, alreadyAdded) => {
    setProdData(data);
    if (checkIfStpSelected()) {
      if (sizes.length > 1 && !alreadyAdded) {
        setOpenSizeModal(true);
      } else {
        onAddToBag({ productData: data, qty: qty, alreadyAdded });
      }
    }
  };

  const decQty = (data, qty, decreasing) => {
    if (checkIfStpSelected()) {
      onAddToBag({ productData: data, qty: qty, decreasing });
    }
  };

  function PromptSelectSize(props) {
    const { onCloseDialog, openDialog } = props;

    return (
      <Dialog
        onClose={onCloseDialog}
        open={openDialog}
      >
        <Box
          sx={{
            p: 3,
            px: 10,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <DialogTitle
            variant='h5'
            sx={{ fontWeight: 'bold' }}
          >
            Select Product Size
          </DialogTitle>

          <Stack
            gap={3}
            direction={'row'}
            sx={{
              width: '100%',
              marginTop: 3,
            }}
          >
            {sizes.map((item) => (
              <Button
                sx={{
                  width: '100%',
                }}
                onClick={() => {
                  setSelectedSize(item.value);
                  onAddToBag({
                    productData: prodData,
                    qty: 1,
                    size: item.value,
                  });
                  onCloseDialog();
                }}
                variant='contained'
              >
                {item.label}
              </Button>
            ))}
          </Stack>
        </Box>
      </Dialog>
    );
  }

  return (
    <>
      <PromptAddShipToParty
        openDialog={promptOpen}
        onCloseDialog={handleClose}
      />

      <PromptSelectSize
        openDialog={openSizeModal}
        onCloseDialog={() => {
          setOpenSizeModal(false);
        }}
      />

      {secondarySchemeModal}
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Stack
          direction={'row'}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <Typography
            variant='h5'
            style={{
              marginBottom: '2rem',
              fontWeight: 'bold',
              alignSelf: 'baseline',
            }}
          >
            Product List
          </Typography>
          <Stack
            direction={'row'}
            spacing={2}
            justifyContent={'center'}
          >
            {!isSecondaryOrder &&
              companyDetails?.secondary_scheme_banners?.length > 0 && (
                <Tooltip title="Company's Secondary Schemes">
                  <Fab
                    color='black'
                    aria-label='add'
                    onClick={() =>
                      handleModalOpen(companyDetails?.secondary_scheme_banners)
                    }
                  >
                    <SecondarySchemeIcon />
                  </Fab>
                </Tooltip>
              )}

            <CartAndAddressComponent
              hideDeliveryDetails={state?.hideDeliveryDetails}
            />
          </Stack>
        </Stack>
        <Stack
          direction={'row'}
          gap={5}
        >
          <Paper
            component='form'
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              ml: '1rem',
              mb: '1rem',
              width: '100%',
            }}
          >
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder='Search Products'
              inputProps={{ 'aria-label': 'search products' }}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                }
              }}
              onChange={(event) => {
                setSearchQuery(event.target.value);
                setIfAutoSuggestionSelected(false);
              }}
              value={searchQuery}
            />
            <IconButton
              type='button'
              sx={{ p: '10px' }}
              aria-label='search'
              onClick={() => {
                handleSearch(searchQuery);
                setIfAutoSuggestionSelected(true);
                setAutoCompleteSuggestions([]);
              }}
            >
              <Search />
            </IconButton>
            <Divider
              sx={{ height: 28, m: 0.5 }}
              orientation='vertical'
            />
            <IconButton
              color='primary'
              sx={{ p: '10px' }}
              aria-label='directions'
              onClick={() => {
                setIsFiltersModalOpen(true);
              }}
            >
              <FilterAlt />
            </IconButton>
          </Paper>
        </Stack>

        {autoCompleteSuggestions && autoCompleteSuggestions.length > 0 && (
          <Paper
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              ml: '1rem',
              mb: '1rem',
            }}
          >
            {' '}
            <List>
              {autoCompleteSuggestions.map((suggestion) => {
                return (
                  <ListItem
                    onClick={() => {
                      setSearchQuery(suggestion.name);
                      handleSearch(suggestion.name);
                      setIfAutoSuggestionSelected(true);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <Typography>{suggestion.name}</Typography>
                  </ListItem>
                );
              })}
            </List>{' '}
          </Paper>
        )}
        <Drawer
          anchor={'right'}
          open={isFiltersModalOpen}
          onClose={toggleDrawer(false)}
        >
          <FilterComponent
            data={filters}
            selectedFiltersList={selectedFiltersList}
            setSelectedFiltersList={setSelectedFiltersList}
            setIsFiltersModalOpen={setIsFiltersModalOpen}
          />
        </Drawer>

        <Grid
          container
          spacing={2}
        >
          {isLoading
            ? Array.from(new Array(9)).map((_, index) => (
                <Grid
                  item
                  xs={3}
                  key={index}
                >
                  <Card
                    sx={{
                      height: '20rem',
                      borderRadius: 5,
                      ml: '1rem',

                      mb: '1rem',
                      pb: '1rem',
                    }}
                  >
                    <CardContent>
                      <Skeleton
                        variant='rectangular'
                        height={200}
                      />
                      <Skeleton variant='text' />
                      <Skeleton variant='text' />
                    </CardContent>
                  </Card>
                </Grid>
              ))
            : productListData.map((product) => {
                return (
                  <>
                    {product ? (
                      <Grid
                        item
                        xs={3}
                      >
                        <Card
                          sx={{
                            height: '25rem',
                            borderRadius: 5,
                            ml: '1rem',

                            mb: '1rem',
                            pb: '1rem',
                            position: 'relative',
                          }}
                        >
                          <CardActionArea
                            sx={{
                              height: '20rem',
                            }}
                            onClick={() => {
                              if (checkIfStpSelected()) {
                                navigate('/order-booking/product-description', {
                                  state: {
                                    productData: product,
                                    isFromEditOrderDetails:
                                      state?.isFromEditOrderDetails,
                                    hideDeliveryDetails:
                                      state?.hideDeliveryDetails,
                                    ship_to_party_id: state?.ship_to_party_id,
                                  },
                                });
                              }
                            }}
                          >
                            <CardMedia
                              component='img'
                              height={'200'}
                              image={product.product_logo}
                              alt={product.name}
                              title={product.name}
                              sx={{ objectFit: 'contain' }}
                            />

                            <CardContent>
                              <Typography
                                gutterBottom
                                variant='subtitle1'
                                component='div'
                                fontWeight={'bold'}
                              >
                                {product.name}
                              </Typography>
                              <Typography
                                variant='subtitle2'
                                color='text.secondary'
                              >
                                {product.sub_product}
                              </Typography>
                              <Stack direction={'row'}>
                                {/* <ThemeProvider> */}
                                <Typography
                                  gutterBottom
                                  variant='subtitle1'
                                  component='div'
                                  sx={{
                                    textDecoration: 'line-through',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  ₹ {product.meta_data.MRP}
                                </Typography>
                                {/* </ThemeProvider> */}

                                <Typography
                                  variant='subtitle1'
                                  color='text.secondary'
                                  sx={{
                                    ml: '0.5rem',
                                    color: '#1fd655',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  ₹{' '}
                                  {!isSecondaryOrder
                                    ? product.meta_data.price.dlp
                                    : product.meta_data.price.rlp}
                                </Typography>
                              </Stack>
                            </CardContent>
                          </CardActionArea>
                          <Stack
                            sx={{
                              position: 'absolute',
                              bottom: '1rem',
                              width: '100%',
                            }}
                          >
                            {(selectedStp?.products?.find(
                              (prod) => prod.product_id === product.product_id,
                            )?.qty || 0) === 0 ? (
                              <Button
                                onClick={() => addQty(product, 1, false)}
                                sx={{
                                  marginLeft: 2,
                                  marginRight: 2,
                                }}
                                variant='outlined'
                              >
                                Add
                              </Button>
                            ) : (
                              <Box
                                sx={{
                                  alignSelf: 'center',
                                }}
                              >
                                <AddRemoveQty
                                  onIncreasePress={(e) => {
                                    const prodQty =
                                      selectedStp?.products?.find(
                                        (prod) =>
                                          prod.product_id ===
                                          product.product_id,
                                      )?.qty || 0;

                                    addQty(
                                      product,
                                      Number(prodQty) + 1,
                                      Number(prodQty) + 1 > 1,
                                    );
                                  }}
                                  onTextChange={(e) => {
                                    addQty(product, e);
                                  }}
                                  quantity={
                                    selectedStp?.products?.find(
                                      (prod) =>
                                        prod.product_id === product.product_id,
                                    )?.qty || 0
                                  }
                                  onReducePress={() => {
                                    const prodQty =
                                      selectedStp?.products?.find(
                                        (prod) =>
                                          prod.product_id ===
                                          product.product_id,
                                      )?.qty || 0;

                                    if (Number(prodQty) - 1 < 0) return;

                                    decQty(product, Number(prodQty) - 1, true);
                                  }}
                                />
                              </Box>
                            )}
                          </Stack>
                        </Card>
                      </Grid>
                    ) : (
                      <Skeleton
                        variant='rectangular'
                        width={210}
                        height={118}
                      />
                    )}
                  </>
                );
              })}
        </Grid>
      </Container>
    </>
  );
}

export default ProductList;
